export enum Periodicity {
  daily = 1,
  daily_business = 2,
  weekly = 3,
  monthly = 4,
  quarterly = 5,
  semi_annual = 6,
  annual = 7,
}
